<template>
  <div
    class="fixed inset-0 overflow-y-auto min-h-screen bg-white text-gray-900 p-4 sm:p-6"
  >
    <header class="text-center mb-8">
      <h1 class="text-3xl sm:text-4xl font-extrabold text-orange-700">
        📚 Kitoblar ro'yxati
      </h1>

      <p v-if="loading" class="mt-4 text-orange-600/70">
        Kitoblar yuklanmoqda...
      </p>

      <p v-else-if="error" class="mt-4 text-red-600">
        {{ error }}
      </p>
    </header>

    <div
      v-if="!loading && !error"
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
    >
      <div
        v-for="book in books"
        :key="book.isbn || book.id"
        class="bg-white sm:bg-orange-50/40 p-5 rounded-2xl shadow-md flex flex-col justify-between border border-orange-200/60 hover:shadow-xl hover:border-orange-300 transition-all duration-300"
      >
        <!-- Muqova -->
        <img
          v-if="book.imageUrl"
          :src="book.imageUrl"
          class="w-full h-64 object-cover rounded-xl mb-4 border border-orange-100 shadow-sm"
          @error="handleImageError"
        />

        <div
          v-else
          class="w-full h-64 bg-orange-50 rounded-xl mb-4 flex items-center justify-center text-orange-400"
        >
          Rasm mavjud emas
        </div>

        <h3 class="font-bold text-xl mb-2 line-clamp-2 text-gray-800">
          {{ book.name || "Noma'lum kitob" }}
        </h3>

        <div class="space-y-1.5 mb-5 text-gray-700 text-sm flex-grow">
          <p><strong>Muallif:</strong> {{ book.author || "-" }}</p>
          <p><strong>Nashriyot:</strong> {{ book.publishingHouse || "-" }}</p>
          <p><strong>Sana:</strong> {{ book.createdAt || "-" }}</p>
          <p><strong>Hajmi:</strong> {{ book.pagesCount || "-" }}</p>
          <p><strong>ISBN:</strong> {{ book.isbn || "-" }}</p>

          <p v-if="book.onSale === false" class="text-red-600 font-medium">
            Hozirda sotuvda emas
          </p>
        </div>

        <div class="flex justify-between items-center w-full mt-auto">
          <span class="text-xl font-bold text-orange-700">
            {{ formatPrice(book.price) }} so'm
          </span>

          <button
            @click="selectBook(book)"
            :disabled="!book.onSale"
            :class="[
              'px-6 py-3 rounded-xl font-semibold text-white shadow-md transition-all duration-200',
              book.onSale
                ? 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700'
                : 'bg-gray-400 cursor-not-allowed',
            ]"
          >
            {{ book.onSale ? "Tanlash" : "Sotuvda yo'q" }}
          </button>
        </div>

        <a
          v-if="book.sayt"
          :href="book.sayt"
          target="_blank"
          class="mt-4 text-sm text-orange-600 hover:text-orange-800 hover:underline block text-center"
        >
          Batafsil ma'lumot →
        </a>
      </div>
    </div>

    <div
      v-if="!loading && books.length === 0 && !error"
      class="text-center py-16 text-orange-600/80 text-lg font-medium"
    >
      Hozircha kitoblar mavjud emas 😔
    </div>
  </div>
</template>

<script>
import { httpPublic } from "@/http";

export default {
  data() {
    return {
      books: [],
      loading: true,
      error: null,
    };
  },

  mounted() {
    this.loadBooks();
  },

  methods: {
    async loadBooks() {
      try {
        this.loading = true;
        this.error = null;

        const query = this.$route.query.query || "";
        const page = this.$route.query.page || 1;

        const response = await httpPublic.get("/v1/book", {
          params: { query, page },
        });

        if (!response.data || !response.data.status) {
          throw new Error("Server javobi muvaffaqiyatsiz");
        }

        this.books = response.data.data?.content || [];
      } catch (err) {
        console.error(err);
        this.error =
          "Kitoblarni yuklab bo'lmadi. Iltimos, internetingizni tekshiring.";
      } finally {
        this.loading = false;
      }
    },

    formatPrice(price) {
      if (price === null || price === undefined) return "—";
      return Number(price).toLocaleString("uz-UZ");
    },

    handleImageError(e) {
      e.target.src = "https://via.placeholder.com/300x400?text=Kitob+rasmi";
    },

    selectBook(book) {
      if (!book.onSale) return;

      const data = {
        action: "book_selected",
        book_id: book.isbn || book.id,
        name: book.name,
        muallif: book.author,
        narxi: book.price,
        imageUrl: book.imageUrl,
      };

      this.tg.showPopup({
        title: "Tanlandi!",
        message: `${book.name}\nNarxi: ${this.formatPrice(book.price)} so'm`,
        buttons: [{ type: "ok" }],
      });

      setTimeout(() => {
        this.tg.sendData(JSON.stringify(data));
      }, 1200);
    },
  },
};
</script>
